import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useRef } from 'react';
import { useTheme } from 'styled-components';
import { useDimensions, useOutsideClick } from '@libs/hooks';
import { screenSizes } from '@libs/theme';
import { DropdownIcon } from '../assets';
import { useModal } from '../modal';
import Typography from '../typography/Typography';
import { CalendarWrapper, CustomSelect, CustomSelectWrapper, DesktopLabel, DialogWrapper, IconWrapper, LabelWrapper, MobileLabel, } from './styles';
export const SelectFilterContainer = ({ toggleSelect, className, isFiltered, isOpen, closeFilter, hasDatesSelected, handleCalendarWrapperClick, selectedDatesLabel, handleOpenModal, label, children, placeHolder, }) => {
    const calendarRef = useRef(null);
    const { Dialog, openModal } = useModal(toggleSelect);
    const { width } = useDimensions();
    const { colors } = useTheme();
    const outsideClickHandler = useCallback(() => {
        if (width <= screenSizes.tablet)
            return;
        closeFilter();
    }, [width]);
    useOutsideClick(calendarRef, outsideClickHandler);
    const handleOpen = (e) => {
        if (width <= screenSizes.tablet) {
            openModal();
        }
        if (handleOpenModal)
            handleOpenModal(e);
    };
    return (_jsxs(CustomSelect, { ref: calendarRef, className: className, isFiltered: isFiltered, placeholder: placeHolder, children: [isOpen && (_jsx(CalendarWrapper, { className: "calendar-wrapper", hasDatesSelected: hasDatesSelected, onClick: handleCalendarWrapperClick, children: children })), _jsxs(CustomSelectWrapper, { onClick: handleOpen, children: [_jsxs(LabelWrapper, { children: [_jsxs("div", { children: [placeHolder && (_jsx(Typography, { type: "caption", color: colors.text.secondary, children: placeHolder })), _jsx(DesktopLabel, { type: "subHeadline", children: selectedDatesLabel || label }), _jsx(MobileLabel, { type: "bodyButton", fontFamily: "primaryBold", isFiltered: isFiltered, children: selectedDatesLabel || label })] }), _jsx(IconWrapper, { className: "select-dropdown-icon", isOpen: isOpen, children: _jsx(DropdownIcon, {}) })] }), isOpen && (_jsx(Dialog, { title: label, children: _jsx(DialogWrapper, { children: children }) }))] })] }));
};
export default SelectFilterContainer;
//# sourceMappingURL=SelectFilterContainer.js.map